import { render, staticRenderFns } from "./RatingSummary.vue?vue&type=template&id=f65467ac&scoped=true"
import script from "./RatingSummary.vue?vue&type=script&lang=js"
export * from "./RatingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65467ac",
  null
  
)

export default component.exports